import { render, staticRenderFns } from "./giftBenefits.vue?vue&type=template&id=053e03a2&scoped=true&"
import script from "./giftBenefits.vue?vue&type=script&lang=js&"
export * from "./giftBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053e03a2",
  null
  
)

export default component.exports